import { render, staticRenderFns } from "./ComponentLoginHistory.vue?vue&type=template&id=29cb9c28"
import script from "./ComponentLoginHistory.vue?vue&type=script&lang=js"
export * from "./ComponentLoginHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports